import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { SiCodechef } from "react-icons/si";
import { SiLeetcode } from "react-icons/si";

const HeaderSocial = () => {
  return (
    <div className="header_socials">
      <a href="https://www.linkedin.com/in/mayank-kr-shah/" target="_1">
        {" "}
        <BsLinkedin />
      </a>
      <a href="https://github.com/Mayank-kr-sh" target="_2">
        {" "}
        <BsGithub />
      </a>
      <a href="https://leetcode.com/Mayank-kr-sh109/" target="_3">
        {" "}
        <SiLeetcode />
      </a>
      <a href="https://www.codechef.com/users/mayank_9009_kr" target="_4">
        {" "}
        <SiCodechef />
      </a>
    </div>
  );
};

export default HeaderSocial;
